<template>
  <div class="content-info" v-show="contentInfoShow">
    <div class="info-title">
      <span class="info-title--prefix"></span>
      <span class="info-title--content">详情</span>
      <img src="@/assets/myImg/1/icon-close.png" class="info-title--sufix" @click="closeOverLay()" />
    </div>
    <div class="info-content">
      <div class="info-content-item" v-for="item in infoData" :key="item.id">
        <span class="info-content-item-name">{{ item.name }}:</span>
        <span v-if="item.hyperlinkUrl" class="info-content-item-value-hyperlink" @click="handleHyperlink(item)">
          {{ item.value }}
        </span>
        <span v-else-if="item.clickable" class="info-content-item-value-clickable" @click="handleClickableField(item)">
          {{ item.value }}
        </span>
        <span v-else class="info-content-item-value">
          {{ item.value }}
        </span>
      </div>
    </div>
    <water-number-modal ref="WaterNumberModal" style="z-index: 9999;"></water-number-modal>
  </div>
</template>
<script>
import { getFeatureConfig, valveTypes } from '../mapModule/featureConfig.js'
import WaterNumberModal from '../WaterNumberModal'
export default {
  components: {
    WaterNumberModal
  },
  name: 'InfoMap',
  data () {
    return {
      contentInfoShow: false,
      infoData: []
    }
  },
  methods: {
    handleFeatureData (feature) {
      console.log('要素数据:', feature)
      this.loadFeatureData(feature)
    },
    loadFeatureData (feature) {
      console.log('要素ID:', feature.id);
      this.contentInfoShow = true;

      // 使用封装的ID判断方法
      const id = this.parseFeatureId(feature);

      // 根据要素ID获取配置
      const config = getFeatureConfig(id);
      if (config) {
        console.log('找到要素配置:', config);
        this.handleFeature(feature.properties, config);
      } else {
        console.log('未找到对应的要素配置');
        this.infoData = [];
      }
    },

    // 解析要素ID，返回标准化的要素类型
    parseFeatureId (feature) {
      const { id, properties } = feature

      if (id.includes('gis_pipe_line')) {
        return 'gis_pipe_line'
      }
      if (id.includes('remote_water_meter')) {
        return 'remote_water_meter_gis'
      }
      if (id.includes('search_pipe_network')) {
        return 'gis_pipe_network'
      }
      if (id.includes('gis_pipe_network')) {
        const { appendage, structure } = properties || {}

        if (appendage && valveTypes[appendage]) {
          return valveTypes[appendage]
        }

        if (appendage) {
          return 'gis_pipe_network_appendage'
        }

        if (structure) {
          return 'gis_pipe_network_structure'
        }

        return 'gis_pipe_network'
      }

      return id
    },

    // 处理管线要素
    handleFeature (data, elements) {
      console.log('处理管线要素数据:', data);

      this.infoData = elements.map(item => {
        const rawValue = data[item.id] || '暂无数据';
        let displayValue = rawValue;
        let hyperlinkUrl = '';

        // 应用格式化规则
        if (item.rule && rawValue !== '暂无数据') {
          displayValue = this.formatValue(rawValue, item.rule);
        }

        // 构建超链接URL
        if (item.hyperlink) {
          hyperlinkUrl = this.buildHyperlinkUrl(item.hyperlink, data);
        }

        // 处理可点击字段的value设置
        let clickableConfig = item.clickable;
        if (clickableConfig && typeof clickableConfig === 'object') {
          // 对于管线的起点/终点分类编码，直接使用当前字段的值
          if (item.id === 'start_class_no' || item.id === 'end_class_no') {
            clickableConfig = {
              ...clickableConfig,
              value: rawValue
            };
          } else if (clickableConfig.type) {
            // 其他情况，从指定字段获取值
            clickableConfig = {
              ...clickableConfig,
              value: data[clickableConfig.type] || ''
            };
          }
        }

        return {
          ...item,
          value: displayValue,
          hyperlinkUrl: hyperlinkUrl,
          clickable: clickableConfig
        };
      });

      console.log('处理后的信息数据:', this.infoData);
    },

    // 格式化值
    formatValue (value, rule) {
      if (rule.position === 'before') {
        return rule.text + value;
      } else if (rule.position === 'after') {
        return value + rule.text;
      }
      return value;
    },

    // 构建超链接URL
    buildHyperlinkUrl (hyperlink, data) {
      let url = hyperlink.url;
      hyperlink.value.forEach(fieldName => {
        const fieldValue = data[fieldName] || '';
        url = url.replace(/=([^&]*)/, '=' + fieldValue);
      });
      return url;
    },
    handleHyperlink (item) {
      console.log('点击了超链接:', item);
      if (item.hyperlink.way === 'open') {
        window.open(item.hyperlinkUrl);
      }
    },

    // 处理可点击字段
    handleClickableField (item) {
      console.log('点击了可点击字段:', item);

      // 根据字段类型执行不同的操作
      switch (item.id) {
        case 'water_count':
          // 水表数量点击处理
          this.handleWaterCountClick(item);
          break;
        case 'start_class_no':
        case 'end_class_no':
          // 起点/终点分类编码点击处理（管线）
          this.handlePipeLineClassNoClick(item);
          break;
        case 'class_no':
          // 分类编码点击处理（物探点）
          this.handlePipeNetworkClassNoClick(item);
          break;
      }
    },

    // 处理水表数量点击
    handleWaterCountClick (item) {
      console.log('水表数量被点击:', item);

      // 获取可点击配置中的value值（即class_no的值）
      const classNo = item.clickable?.value || '';
      console.log('获取到的class_no值:', classNo);
      this.$refs.WaterNumberModal.edit(classNo)
    },

    /**
     * 处理管线分类编码点击（起点或终点分类编码）
     * @param {Object} item - 点击的字段项
     */
    handlePipeLineClassNoClick (item) {
      console.log('管线分类编码被点击:', item);
      
      // 获取分类编码的值
      const classNo = item.value || '';
      if (!classNo || classNo === '暂无数据') {
        this.$message.warning('该分类编码暂无数据');
        return;
      }

      console.log('跳转到管线数据页面，分类编码:', classNo);
      
      // 跳转到管线数据页面，并传递分类编码参数
      this.$router.push({
        path: '/pipe-network/gis-pipe-line/index',
        query: {
          classNo: classNo,
          autoSearch: true  // 标记需要自动搜索
        }
      });
    },

    /**
     * 处理物探点分类编码点击
     * @param {Object} item - 点击的字段项
     */
    handlePipeNetworkClassNoClick (item) {
      console.log('物探点分类编码被点击:', item);
      
      // 获取分类编码的值
      const classNo = item.value || '';
      if (!classNo || classNo === '暂无数据') {
        this.$message.warning('该分类编码暂无数据');
        return;
      }

      console.log('跳转到物探点数据页面，分类编码:', classNo);
      
      // 跳转到物探点数据页面，并传递分类编码参数
      this.$router.push({
        path: '/pipe-network/gis-pipe-network/index',
        query: {
          classNo: classNo,
          autoSearch: true  // 标记需要自动搜索
        }
      });
    },

    closeOverLay () {
      this.contentInfoShow = false
      // 告知父组件清除矢量图层
      this.$emit('close-overlay')
    }
  }
}
</script>
<style lang="less" scoped>
.content-info {
  position: absolute;
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  top: 3%;
  right: 24px;
  z-index: 5;
  width: 240px;

  .info-title {
    background-image: linear-gradient(270deg, rgba(7, 142, 231, 0.959) 0%, #0890f2 100%);
    border-radius: 6px 6px 0 0;
    display: flex;
    height: 46px;
    align-items: center;
    color: #ffffff;
    // margin-bottom: 9px;

    .info-title--prefix {
      width: 4px;
      height: 12px;
      background-color: #0890f2;
      margin-right: 5px;
      margin-left: 12px;
    }

    .info-title--content {
      width: 100%;
      flex: 1;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 12px;
      color: #ffffff;
      font-weight: 600;
      line-height: 12px;
      height: 12px;
    }

    .info-title--sufix {
      width: 12px;
      height: 12px;
      margin-right: 12px;
    }
  }

  .info-content {
    padding: 12px;

    .info-content-item {
      line-height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .info-content-item-name {
      font-size: 14px;
      color: #ffffff;
    }

    .info-content-item-value {
      font-size: 14px;
      color: #ffffff;
    }

    .info-content-item-value-hyperlink {
      color: #0890f2;
      cursor: pointer;
    }

    .info-content-item-value-clickable {
      color: #52c41a;
      cursor: pointer;
      text-decoration: underline;
      transition: all 0.3s ease;

      &:hover {
        color: #389e0d;
        text-decoration: none;
      }
    }
  }
}
</style>